'use strict';

import util from '../util';
import login from '../login';
import customModal from '../modal';
import cardValidation from './checkout/card-validation';
import validator from '../validator';
import search from './search';
import productTile from '../product-tile';
import currentLayout from '../detect-layout';
import index from './product/index';
import adyenCheckout from '../adyen/adyen-checkout';

let currLayout = currentLayout.init();

/**
 * @private
 * @function
 * @description Toggles the list of Orders
 */
function toggleFullOrder() {
	$('.order-items')
		.find('li.hidden:first')
		.prev('li')
		.append('<a class="toggle">View All</a>')
		.children('.toggle')
		.click(function () {
			$(this).parent().siblings('li.hidden').show();
			$(this).remove();
		});
}

/**
 * @private
 * @function
 * @description Binds the events on the address form (edit, create, delete)
 */
function initAddressEvents() {
	var addresses = $('#addresses');
	if (addresses.length === 0) {
		return;
	}

	$(document)
		.on('click', '.address-create', function (e) {
			e.preventDefault();
			$('.ajax-loader').show();
			$.ajax({
				url: util.appendParamToURL(Urls.checkoutAddAccountAddress, 'format', 'ajax'),
				dataType: 'html',
				success: function (response) {
					if (response.indexOf('header-wrapper') === -1) {
						customModal.createCustomModal('edit-add-address', '#modal-custom-placeholder');
						$('.edit-add-address').find('.modal-body').html(response);
						util.bodyPositionFixed('edit-add-address');
						$('.ajax-loader').hide();
					}
				}
			}).complete(function (data) {
				$('select').selectmenu();
				$('.edit-add-address .modal-body').scrollBox();
				validator.initStateValidation();
				validator.initForm('form[id="EditAddressForm"]');
			});

		})
		.on('click', '.account-address-edit', function (evt) {
			var element = document.getElementById(evt.currentTarget.id);
			var addressID = element.dataset.addressId;
			var addressCode = element.dataset.addressCode;
			var url = Urls.checkoutEditAccountAddress + encodeURIComponent(addressID);
			$('.ajax-loader').show();
			$.ajax({
				url: util.appendParamToURL(url, 'format', 'ajax'),
				dataType: 'html',
				success: function (response) {
					if (response.indexOf('header-wrapper') === -1) {
						customModal.createCustomModal('edit-add-address', '#modal-custom-placeholder');
						$('.edit-add-address').find('.modal-body').html(response);
						util.bodyPositionFixed('edit-add-address');
						$('.ajax-loader').hide();
					}
				}
			}).complete(function (data) {
				$('select').selectmenu();
				validator.initStateValidation();
				validator.initForm('form[id="EditAddressForm"]');
				$('.edit-add-address .modal-body').scrollBox();
			});
		})
		.on('click', '.address-delete', function () {
			var href = $(this).attr('href');
			$('.remove-address-cc-cta').off('click').on('click', function (e) {
				e.preventDefault();
				$.ajax({
					url: util.appendParamToURL(href, 'format', 'ajax'),
					dataType: 'json'
				}).done(function (data) {
					location.reload();
				});
			});
		});
}

/**
 * @private
 * @function
 * @description Binds the events of the payment methods list (delete card)
 */
function initPaymentEvents() {
	$(document)
		.on('click', '.credit-card-create', function (evt) {
			evt.preventDefault();
			$('.ajax-loader').show();
			$.ajax({
				url: util.appendParamToURL(window.Urls.myaccountAddCreditCard, 'format', 'ajax'),
				dataType: 'html',
				success: function (response) {
					if (response.indexOf('header-wrapper') === -1) {
						customModal.createCustomModal('add-credit-card', '#modal-custom-placeholder');
						$('.add-credit-card').find('.modal-body').html(response);
						util.bodyPositionFixed('add-credit-card');
						creditCardTypeDetector();
						validator.initForm('form[id$="CreditCardForm"]');
						$('.ajax-loader').hide();
					}
				}
			}).done(function (data) {
				$('form[id$="CreditCardForm"] .input-text.cvn').val('');
				$('select').selectmenu();
				cardValidation.init();
				initAdyenComponent();
				$('.add-credit-card .modal-body').scrollBox();
			});
		})
		.on('submit', '#CreditCardForm', function (evt) {
			evt.preventDefault();
			var $form = $(this);
			$('.modal-close').trigger('click');
			$('.ajax-loader').show();
			$.ajax({
				url: util.appendParamToURL($form.attr('action'), 'format', 'ajax', Constants.CSRF_TOKEN_NAME, $('meta[name="csrf-token"]').attr('content')),
				data: $form.serialize() + '&' + $form.find('#applyBtn').attr('name') + '=x',
				type: 'POST'
			}).done(function (data) {
				if (data.length) {
					$('.ajax-loader').hide();
					window.location.href = Urls.paymentInstrumentsList;
				}
			});
		})
		.on('click', '.card-delete', function () {
			var href = $(this).attr('href');
			var $button = $(this);
			var $form = $button.closest('form.remove-card-form');
			$('.cardDelete-modal-btn-ok').off('click').on('click', function (e) {
				e.preventDefault();
				$('.modal-close').trigger('click');
				$('.ajax-loader').show();
				$('<input/>').attr({
					type: 'hidden',
					name: $button[0].dataset.cardname,
					value: $button[0].dataset.cardvalue || 'delete card'
				}).appendTo($form);
				var data = $form.serialize();
				$.ajax({
					url: $form.attr('action'),
					data: data,
					method: 'POST'
				}).done(function (data) {
					$('.ajax-loader').hide();
					window.location.reload();
				});
			});
		});
}

function initAdyenComponent() {
    // Modal rendered first and after that Adyen form component load - Unable to check with promise's here
    setTimeout(() => {
        if (SitePreferences.ADYEN_SF_ENABLED) {
            adyenCheckout.initAccount();
			$(window).trigger('resize.scrollBox');
            $('.input-checkbox.setasdefault').val(false);
            $('.input-checkbox.setasdefault').prop('checked',false);
            $('.input-checkbox.setasdefault').change(function () {
                if ($('.input-checkbox.setasdefault').is(':checked')) {
                    $('.input-checkbox.setasdefault').val(true);
                    $('.input-checkbox.setasdefault').prop('checked',true);
                }
            });
        }
    }, 2500);
};

function registerAccountEvents() {
	// get the field elements
	var $gender = $('.registration-box #dwfrm_profile_customer_gender');
	var $newsletterCB = $('.registration-box #dwfrm_profile_customer_addtoemaillist');

	$gender.on('selectmenuchange change', function (e) {
		$(this).closest('form').find('button[type="submit"]').prop('disabled', false);
		$(this).selectmenu('refresh');
	});
	$newsletterCB.on('change', function (e) {
		$(this).closest('form').find('button[type="submit"]').prop('disabled', false);
	});
    if(window.User.isExternallyAuthenticated=='Social') {
        if($('#dwfrm_profile_customer_firstname').val()=='') {
            $('#dwfrm_profile_customer_firstname').blur();
        }
        if($('#dwfrm_profile_customer_lastname').val()=='') {
            $('#dwfrm_profile_customer_lastname').blur();
        }
    }
}

function initContactUs() {
	var registrationForm = $('form#RegistrationForm');

	registrationForm.on('click', 'button#sendBtn', function (e) {
		e.preventDefault();

		$.ajax({
				url: util.appendParamToURL(Urls.customerServiceSubmit, 'format', 'ajax'),
				data: registrationForm.serialize(),
				method: 'POST'
			})
			.done(function (response) {
				if (response.status) {
					var modalBody = $('#contact-response').html();
					customModal.createCustomModal('customer-contact-us-modal', '#modal-custom-placeholder');
					$('.customer-contact-us-modal').find('.modal-body').html(modalBody);

					clearContactUsForm();
				}
			});
	});
}

function initAsktheExpert() {
	var askexpertform = $('form#dwfrm_beautyconsultant');
	askexpertform.on('click', 'button#sendBtn', function (e) {
		e.preventDefault();
		$('.ajax-loader').show();
		var hasError = askexpertform.find('span.error');
		$.ajax({
				url: util.appendParamToURL(Urls.customerServiceSubmit, 'format', 'ajax'),
				data: askexpertform.serialize(),
				method: 'POST'
			})
			.done(function (response) {
				if (!hasError.length) {
					var modalBody = $('#askexpert-response').html();
					customModal.createCustomModal('concierge-modal', '#modal-custom-placeholder');
					$('#concierge-modal').find('.modal-body').html(modalBody);
					clearAskExpertForm();
				}
				$('.ajax-loader').hide()
			});

	});

}

function maxLengthTextArea() {
	$('.concierge-form-wrapper .input-textarea').onkeypress = function () {
		if (this.value.length >= 500) return false;
	}

}
/**
 * Clear Ask the expert form
 */
function clearAskExpertForm() {
	var askexpertform = $('form#dwfrm_beautyconsultant');
	if (window.User.isCustomerAuthenticated == false) {
		askexpertform.find('input[type="text"],input[type="email"]').val('');
	}
	askexpertform.find('input[type="checkbox"]').prop("checked", false);
	askexpertform.find('textarea').val('');
	askexpertform.find("select").prop('selectedIndex', 0);
	askexpertform.find("select").selectmenu("refresh");
	$('input[name$="_userconsent_termsandconditions"]').prop("checked", false);
}
/**
 * Clear contact us form
 */
function clearContactUsForm() {
	if (window.User.isCustomerAuthenticated == false) {
		$('input[name$="_contactus_firstname"]').val('');
		$('input[name$="_contactus_lastname"]').val('');
		$('input[name$="_contactus_email"]').val('');
		$('input[name$="_contactus_phone"]').val('');
	}

	$('input[name$="_contactus_ordernumber"]').val('');
	$('textarea[name$="_contactus_comment"]').val('').change();
	$('input[name$="_userconsent_termsandconditions"]').prop("checked", false);
}


function setGender() {
	var genderMenu = $('.registration-box #dwfrm_profile_customer_gender');
	var selectedGender = genderMenu.data('gender');
	genderMenu.val(selectedGender);
	genderMenu.selectmenu("refresh");
}

function getBirthday(birthmonth, dob, birthyear) {
	var birthday = [
		birthmonth,
		'/',
		dob,
		'/',
		birthyear
	].join('');

	if (birthday === '00/00/' || birthday === '0/0/') {
		birthday = '';

		$('.birthmonth select').val('00');
		$('.dob select').val('00');
	}

	$('.birthday input').val(birthday);
}

function setBirthday() {
	//Birth Month
	var birthmonthMenu = $('#dwfrm_profile_customer_birthmonth');
	var birthmonth = ('0' + birthmonthMenu.data('birthmonth')).slice(-2);
	if (birthmonth && birthmonth > 0) {
		birthmonthMenu.val(birthmonth);
		birthmonthMenu.selectmenu("refresh");
	}

	//Birth Day
	var dobMenu = $('#dwfrm_profile_customer_dob');
	var dob = ('0' + dobMenu.data('dob')).slice(-2);
	if (dob && dob > 0) {
		dobMenu.val(dob);
		dobMenu.selectmenu("refresh");
	}

	//Birth Year
	var birthyear = $('input.birthyear').data('birthyear');
	$('input.birthyear').val(birthyear);

	getBirthday(birthmonth, dob, birthyear);
}

function setNewBirthday(birthmonth, dob, birthyear) {
	var monthField = $('.birthmonth select');
	var dayField = $('.dob select');
	var yearField = $('.birthyear input');

	var month = ~~birthmonth ? birthmonth : '';
	var day = ~~dob ? dob : '';
	var year = ~~birthyear ? birthyear : '';

	yearField.siblings('.error').remove();
	yearField.removeClass('.error');

	if (month || day || year) {
		var now = new Date();
		var birthday = new Date(birthyear, birthmonth - 1, dob, 0, 0, 0, 0);

		if (!month.match(/^[\d]{1,2}$/) ||
			!day.match(/^[\d]{1,2}$/) ||
			!year.match(/^[\d]{4}$/) ||
			!birthday.getTime() ||
			now.getTime() <= birthday.getTime()) {

			var customRow = $('.birthdate .form-row-custom');

			if ($(customRow).find('.error-placement').length === 0) {
				$('<div class="error-placement"><i class="error-icon"></i><span class="error">' + Resources.INVALID_BIRTHDAY + '</span></div>').appendTo(customRow);
			}
			yearField.addClass('error');
			$('#profile-save-changes').prop('disabled', true);
		}
	}

	getBirthday(birthmonth, dob, birthyear);

	var hasError = $('#profile-save-changes').closest('form').find('span.error');

	if (!hasError.length) {
		$('#profile-save-changes').prop('disabled', false);
	}
}

function updateBirthday() {
	var birthday = $('.birthday input').val();
	var birthmonth = $('.birthmonth select').val();
	var dob = $('.dob select').val();
	var birthyear = $('.birthyear input').val();

	$('.birthmonth select').on('selectmenuchange change', function () {
		birthmonth = $(this).val();

		if (birthyear || (birthmonth === '00' && !birthyear)) {
			setNewBirthday(birthmonth, dob, birthyear);
		}
		$(this).selectmenu('refresh');
	});

	$('.dob select').on('selectmenuchange change', function () {
		dob = $(this).val();

		if (birthyear || (dob === '00' && !birthyear)) {
			setNewBirthday(birthmonth, dob, birthyear);
		}
		$(this).selectmenu('refresh');
	});

	$('.birthyear input').blur(function () {
		birthyear = $(this).val();

		setNewBirthday(birthmonth, dob, birthyear);
	})
}

function handleDisplayselectedCard(currentcard, $selectedCards) {
	$selectedCards.find('.card-icon').addClass('other-cards');
	$selectedCards.find("[data-card-type='" + currentcard + "']").removeClass('other-cards').addClass("current-card");
}

function creditCardTypeDetector(options) {

	// the regular expressions check for possible matches as you type, hence the OR operators based on the number of chars
	// Visa
	var visa_regex = new RegExp('^4[0-9]{0,15}$'),

		// MasterCard
		mastercard_regex = new RegExp('^5$|^5[1-5][0-9]{0,14}$'),

		// American Express
		amex_regex = new RegExp('^3$|^3[47][0-9]{0,13}$'),

		//Discover
		discover_regex = new RegExp('^6[05]$|^601[1]?$|^65[0-9][0-9]?$|^6(?:011|5[0-9]{2})[0-9]{0,12}$'),

		//JCB
		unionpay_regex = new RegExp('^62[0-9]{0,14}$|^645[0-9]{0,13}$|^65[0-9]{0,14}$');

	$('.cc-number input').focusout(function (e) {
		var cur_val = $(this).val();

		var $ccNumberContain = $(this).parents('.cc-number');
		var $selectedCards = $('.available-cards');

		// get rid of spaces and dashes before using the regular expression
		cur_val = cur_val.replace(/ /g, '').replace(/-/g, '');

		var $creditCard = $('[data-method="CREDIT_CARD"]');

		// checks per each, as their could be multiple hits
		if (cur_val.match(visa_regex)) {
			$ccNumberContain.addClass('is_visa');
			$selectedCards.addClass('is_visa');
			handleDisplayselectedCard('is_visa', $selectedCards);
			$creditCard.find('input[name$="_type"]').val("Visa").trigger('change');
		} else {
			$ccNumberContain.removeClass('is_visa');
			$selectedCards.removeClass('is_visa', $selectedCards);
		}

		if (cur_val.match(mastercard_regex)) {
			$ccNumberContain.addClass('is_mastercard');
			$selectedCards.addClass('is_mastercard');
			handleDisplayselectedCard('is_mastercard', $selectedCards);
			$creditCard.find('input[name$="_type"]').val("MasterCard").trigger('change');
		} else {
			$ccNumberContain.removeClass('is_mastercard');
			$selectedCards.removeClass('is_mastercard', $selectedCards);
		}

		if (cur_val.match(amex_regex)) {
			$ccNumberContain.addClass('is_amex');
			$selectedCards.addClass('is_amex');
			handleDisplayselectedCard('is_amex', $selectedCards);
			$creditCard.find('input[name$="_type"]').val("Amex").trigger('change');
		} else {
			$ccNumberContain.removeClass('is_amex');
			$selectedCards.removeClass('is_amex', $selectedCards);
		}

		if (cur_val.match(discover_regex)) {
			$ccNumberContain.addClass('is_discover');
			$selectedCards.addClass('is_discover');
			handleDisplayselectedCard('is_discover', $selectedCards);
			$creditCard.find('input[name$="_type"]').val("Discover").trigger('change');
		} else {
			$ccNumberContain.removeClass('is_discover');
			$selectedCards.removeClass('is_discover', $selectedCards);
		}

		if (cur_val.match(unionpay_regex)) {
			$ccNumberContain.addClass('is_unionpay');
			$selectedCards.addClass('is_unionpay');
			handleDisplayselectedCard('is_unionpay', $selectedCards);
			$creditCard.find('input[name$="_type"]').val("Union").trigger('change');
		} else {
			$ccNumberContain.removeClass('is_unionpay');
			$selectedCards.removeClass('is_unionpay', $selectedCards);
		}

		// if nothing is a hit we add a class to fade them all out
		if (cur_val != '' && !cur_val.match(visa_regex) && !cur_val.match(mastercard_regex) &&
			!cur_val.match(amex_regex) && !cur_val.match(discover_regex) && !cur_val.match(unionpay_regex)) {
			$ccNumberContain.addClass('is_nothing');
		} else {
			$ccNumberContain.removeClass('is_nothing');
		}
	});

};

//function to highlight the selected page on navigation bar
function setAccountNavText(checkLayout) {
	if ($(".account-left-nav").length > 0) {
		var selectvar = $('.selected-page').val() || '';
		$(".account-left-nav li[data-attr='" + selectvar + "']").addClass("selected");
		if (checkLayout === 'mobile' && $(".account-left-nav li[data-attr='" + selectvar + "']").length > 0) {
			if (selectvar != "account-overview") {
				$('.pt_account #secondary-navigation').animate({
					scrollLeft: $(".account-left-nav li[data-attr='" + selectvar + "']").offset().left
				});
			}
		}
	}
}

$(window).on('orientationchange', function () {
	currLayout = currentLayout.init();
	setAccountNavText(currLayout);
});

/**
 * @private
 * @function
 * @description Binds the events of the order, address and payment pages
 */
function initializeEvents() {
	cardValidation.init();
	toggleFullOrder();
	initAddressEvents();
	initPaymentEvents();
	login.init();
	registerAccountEvents();
	initContactUs();
	initAsktheExpert();
	maxLengthTextArea();
	setGender();
	setBirthday();
	updateBirthday();
	search.viewMore();
	productTile.init();
	setAccountNavText(currLayout);
}


var account = {
	init: function () {
		initializeEvents();
	},
	initCartLogin: function () {
		login.init();
	},
	initPaymentEvents: function () {
		initPaymentEvents();
	}
};

export default account;